import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-content-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Active Audit File:", -1)
const _hoisted_4 = { class: "text-primary ml-2" }
const _hoisted_5 = { class: "my-1" }
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "formgrid grid" }
const _hoisted_8 = { class: "field col flex flex-column my-2 gap-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50 mb-0",
  for: "a1"
}, "A1", -1)
const _hoisted_10 = { class: "field col flex flex-column my-2 gap-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50 mb-0",
  for: "b1"
}, "B1", -1)
const _hoisted_12 = { class: "field col flex flex-column my-2 gap-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50 mb-0",
  for: "c1"
}, "C1", -1)
const _hoisted_14 = { class: "formgrid grid" }
const _hoisted_15 = { class: "field col flex flex-column my-2 gap-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50 mb-0",
  for: "ai"
}, "Ai", -1)
const _hoisted_17 = { class: "field col flex flex-column my-2 gap-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50 mb-0",
  for: "bi"
}, "Bi", -1)
const _hoisted_19 = { class: "field col flex flex-column my-2 gap-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50 mb-0",
  for: "ci"
}, "Ci", -1)
const _hoisted_21 = {
  key: 1,
  class: "flex justify-content-between align-items-center"
}
const _hoisted_22 = {
  key: 1,
  class: "flex align-items-center"
}
const _hoisted_23 = {
  key: 2,
  class: "flex align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PBlockUI = _resolveComponent("PBlockUI")!
  const _component_WAppMode = _resolveComponent("WAppMode")!
  const _component_PRadioButton = _resolveComponent("PRadioButton")!
  const _component_PFileUpload = _resolveComponent("PFileUpload")!
  const _component_PPanel = _resolveComponent("PPanel")!
  const _component_PInputNumber = _resolveComponent("PInputNumber")!
  const _component_PSplitButton = _resolveComponent("PSplitButton")!
  const _component_PProgressSpinner = _resolveComponent("PProgressSpinner")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PFieldset = _resolveComponent("PFieldset")!
  const _component_InvoiceChart = _resolveComponent("InvoiceChart")!
  const _component_PCard = _resolveComponent("PCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PBlockUI, {
      blocked: _ctx.loading,
      fullScreen: ""
    }, null, 8, ["blocked"]),
    _createVNode(_component_PCard, { class: "min-h-screen" }, {
      content: _withCtx(() => [
        _createVNode(_component_PFieldset, { legend: "Application Mode" }, {
          default: _withCtx(() => [
            _createVNode(_component_WAppMode),
            (_ctx.auditing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_ctx.selectedAuditFile != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _hoisted_3,
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedAuditFile), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_PPanel, {
                    loading: _ctx.loading,
                    class: "my-3",
                    header: "Audit files",
                    toggleable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auditFilesList, (filename, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "flex justify-content-start align-items-center my-2"
                        }, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_PRadioButton, {
                              inputId: `file_${i}`,
                              value: filename,
                              name: "dynamic",
                              modelValue: _ctx.selectedAuditFile,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAuditFile) = $event))
                            }, null, 8, ["inputId", "value", "modelValue"]),
                            _createElementVNode("label", {
                              for: `file_${i}`,
                              class: "cursor-pointer ml-2"
                            }, _toDisplayString(filename), 9, _hoisted_6)
                          ])
                        ]))
                      }), 128)),
                      _createVNode(_component_PFileUpload, {
                        maxFileSize: 10000000,
                        multiple: false,
                        url: _ctx.uploadUrl,
                        onBeforeSend: _ctx.onBeforeSend,
                        onError: _ctx.onError,
                        onUpload: _ctx.onUpload,
                        accept: "text/csv",
                        chooseLabel: "Add file",
                        class: "mt-3",
                        invalidFileSizeMessage: "File size should be less than 10MB",
                        invalidFileTypeMessage: "Invalid file type. Please upload a CSV file",
                        label: "Upload CSV File",
                        mode: "basic",
                        name: "audit_file",
                        size: "small"
                      }, null, 8, ["url", "onBeforeSend", "onError", "onUpload"])
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_ctx.auditing && _ctx.auditFilesList.length > 0)
                ? (_openBlock(), _createBlock(_component_PPanel, {
                    key: 0,
                    loading: _ctx.loading,
                    class: "my-3",
                    header: "Coefficients settings",
                    toggleable: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createVNode(_component_PInputNumber, {
                            maxFractionDigits: 50,
                            minFractionDigits: 0,
                            useGrouping: false,
                            autocomplete: "off",
                            id: "a1",
                            mode: "decimal",
                            size: "small",
                            style: {"width":"200px"},
                            modelValue: _ctx.a1,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.a1) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_PInputNumber, {
                            maxFractionDigits: 50,
                            minFractionDigits: 0,
                            useGrouping: false,
                            autocomplete: "off",
                            id: "b1",
                            mode: "decimal",
                            size: "small",
                            style: {"width":"200px"},
                            modelValue: _ctx.b1,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.b1) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createVNode(_component_PInputNumber, {
                            maxFractionDigits: 50,
                            minFractionDigits: 0,
                            useGrouping: false,
                            autocomplete: "off",
                            id: "c1",
                            mode: "decimal",
                            size: "small",
                            style: {"width":"200px"},
                            modelValue: _ctx.c1,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.c1) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createVNode(_component_PInputNumber, {
                            maxFractionDigits: 50,
                            minFractionDigits: 0,
                            useGrouping: false,
                            autocomplete: "off",
                            id: "ai",
                            mode: "decimal",
                            size: "small",
                            style: {"width":"200px"},
                            modelValue: _ctx.ai,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ai) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_PInputNumber, {
                            maxFractionDigits: 50,
                            minFractionDigits: 0,
                            useGrouping: false,
                            autocomplete: "off",
                            id: "bi",
                            mode: "decimal",
                            size: "small",
                            style: {"width":"200px"},
                            modelValue: _ctx.bi,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bi) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createVNode(_component_PInputNumber, {
                            maxFractionDigits: 50,
                            minFractionDigits: 0,
                            useGrouping: false,
                            autocomplete: "off",
                            id: "ci",
                            mode: "decimal",
                            size: "small",
                            style: {"width":"200px"},
                            modelValue: _ctx.ci,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ci) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.auditing && _ctx.auditFilesList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_ctx.selectedAuditFile != '')
                    ? (_openBlock(), _createBlock(_component_PSplitButton, {
                        key: 0,
                        model: _ctx.tariffCalculationsButtonItems,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doTariffCalculations('final'))),
                        class: "mt-3",
                        label: "Generate Invoice",
                        size: "small"
                      }, null, 8, ["model"]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createTextVNode(_toDisplayString(_ctx.generatingInvoiceMessage) + " ", 1),
                        _createVNode(_component_PProgressSpinner, {
                          animationDuration: "0.5s",
                          class: "ml-2",
                          strokeWidth: "6",
                          style: {"width":"25px","height":"25px"}
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.invoiceFilename != '' && !_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_PButton, {
                          label: _ctx.downloadButtonLabel,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadInvoice())),
                          class: "mt-3",
                          size: "small",
                          text: ""
                        }, null, 8, ["label"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_PButton, {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveAuditSettings())),
                    class: "mt-3",
                    label: "Save audit settings",
                    size: "small"
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_InvoiceChart)
      ]),
      _: 1
    })
  ], 64))
}